var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBootcampjscalendario(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_1642)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_158_1642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.32634 6.50614C7.11836 5.93071 8.07323 5.63268 9.375 5.47833V6.5625C9.375 7.59803 10.2145 8.4375 11.25 8.4375C12.2855 8.4375 13.125 7.59803 13.125 6.5625V5.31601C13.7051 5.3125 14.3285 5.3125 15 5.3125C15.6715 5.3125 16.2949 5.3125 16.875 5.31601V6.5625C16.875 7.59803 17.7145 8.4375 18.75 8.4375C19.7855 8.4375 20.625 7.59803 20.625 6.5625V5.47833C21.9268 5.63268 22.8816 5.93071 23.6737 6.50614C24.2043 6.89164 24.6709 7.35825 25.0564 7.88884C25.7618 8.85979 26.0503 10.0755 26.1683 11.875H3.83167C3.94968 10.0755 4.23821 8.85979 4.94364 7.88884C5.32914 7.35825 5.79575 6.89164 6.32634 6.50614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76337 13.7497C3.75 14.5823 3.75 15.5137 3.75 16.5625C3.75 21.2497 3.75 23.5933 4.94364 25.2362C5.32914 25.7668 5.79575 26.2334 6.32634 26.6189C7.96925 27.8125 10.3128 27.8125 15 27.8125C16.0487 27.8125 16.98 27.8125 17.8125 27.7991L17.8125 27.7115C17.8124 26.6465 17.8124 25.9977 17.901 25.4381C18.3881 22.3627 20.8001 19.9506 23.8756 19.4635C24.4352 19.3749 25.084 19.3749 26.149 19.375L26.2366 19.375C26.25 18.5425 26.25 17.6112 26.25 16.5625C26.25 15.5137 26.25 14.5822 26.2366 13.7497L26.2137 13.75H3.78601L3.76337 13.7497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6737 26.6189C22.7027 27.3243 21.487 27.6128 19.6875 27.7308C19.6877 26.5929 19.6919 26.1169 19.7529 25.7314C20.1129 23.4583 21.8958 21.6754 24.1689 21.3154C24.5544 21.2544 25.0304 21.2502 26.1683 21.25C26.0503 23.0495 25.7618 24.2652 25.0564 25.2362C24.6709 25.7668 24.2043 26.2334 23.6737 26.6189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 2.8125C12.1875 2.29473 11.7678 1.875 11.25 1.875C10.7322 1.875 10.3125 2.29473 10.3125 2.8125V6.5625C10.3125 7.08027 10.7322 7.5 11.25 7.5C11.7678 7.5 12.1875 7.08027 12.1875 6.5625V2.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 2.8125C19.6875 2.29473 19.2678 1.875 18.75 1.875C18.2322 1.875 17.8125 2.29473 17.8125 2.8125V6.5625C17.8125 7.08027 18.2322 7.5 18.75 7.5C19.2678 7.5 19.6875 7.08027 19.6875 6.5625V2.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8125 4.92295L9.31613 4.9818C7.96966 5.14146 6.92034 5.45654 6.03245 6.10164C5.45941 6.51797 4.95547 7.02191 4.53914 7.59495C3.74897 8.68251 3.45257 10.015 3.33274 11.8423L3.29781 12.375H3.83167H26.1683H26.7022L26.6673 11.8423C26.5474 10.015 26.251 8.68251 25.4609 7.59495C25.0445 7.02191 24.5406 6.51797 23.9676 6.10164C23.0797 5.45654 22.0303 5.14146 20.6839 4.9818L20.1875 4.92295V2.8125C20.1875 2.01859 19.5439 1.375 18.75 1.375C17.9561 1.375 17.3125 2.01859 17.3125 2.8125V4.81865L16.878 4.81602C16.2964 4.8125 15.6717 4.8125 15.001 4.8125H15H14.999C14.3283 4.8125 13.7036 4.8125 13.122 4.81602L12.6875 4.81865V2.8125C12.6875 2.01859 12.0439 1.375 11.25 1.375C10.4561 1.375 9.8125 2.01859 9.8125 2.8125V4.92295ZM3.76935 13.2498L3.27143 13.2438L3.26344 13.7417C3.25 14.5782 3.25 15.513 3.25 16.5595V16.5625V16.5936C3.25 18.9109 3.24999 20.6907 3.40211 22.0948C3.55593 23.5145 3.87007 24.6092 4.53914 25.5301L4.93987 25.2389L4.53914 25.5301C4.95547 26.1031 5.45941 26.607 6.03245 27.0234C6.95334 27.6924 8.04802 28.0066 9.46772 28.1604C10.8718 28.3125 12.6516 28.3125 14.9688 28.3125H15H15.0022C16.0489 28.3125 16.9838 28.3125 17.8205 28.2991L18.3125 28.2912L18.3125 27.7991L18.3125 27.7115C18.3124 26.6305 18.3138 26.028 18.3948 25.5163C18.8481 22.6548 21.0923 20.4106 23.9538 19.9573C24.4655 19.8763 25.068 19.8749 26.1489 19.875L26.2366 19.875L26.7287 19.875L26.7366 19.383C26.75 18.5466 26.75 17.6119 26.75 16.5656V16.5625V16.5598C26.75 15.5132 26.75 14.5783 26.7366 13.7417L26.7286 13.2437L26.2306 13.2498L26.2107 13.25H3.78896L3.76935 13.2498ZM19.1875 27.7308L19.1874 28.2647L19.7202 28.2298C21.5475 28.1099 22.88 27.8135 23.9675 27.0234C24.5406 26.607 25.0445 26.1031 25.4609 25.5301C26.251 24.4425 26.5474 23.11 26.6673 21.2827L26.7022 20.7499L26.1683 20.75C25.0488 20.7502 24.5247 20.7528 24.0907 20.8216C21.6036 21.2155 19.653 23.1661 19.2591 25.6532C19.1903 26.0872 19.1877 26.6113 19.1875 27.7308Z",
    stroke: "url(#paint0_linear_158_1642)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_158_1642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 16.875C10.7322 16.875 10.3125 17.2947 10.3125 17.8125C10.3125 18.3303 10.7322 18.75 11.25 18.75H18.75C19.2678 18.75 19.6875 18.3303 19.6875 17.8125C19.6875 17.2947 19.2678 16.875 18.75 16.875H11.25Z",
    fill: "#062A6A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_158_1642",
    x: -21.25,
    y: -23.125,
    width: 72.5,
    height: 75.9375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_158_1642"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_158_1642",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_158_1642",
    x: 7.3125,
    y: 13.875,
    width: 25.375,
    height: 17.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_1642"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_158_1642",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_158_1642",
    x1: 3.75,
    y1: 1.875,
    x2: 29.4369,
    y2: 24.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_1642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampjscalendario);
export default __webpack_public_path__ + "static/media/Bootcamp js calendario.fd26d0ac8f8b0cbc5c3fd780da33c42d.svg";
export { ForwardRef as ReactComponent };